export default __webpack_public_path__ + "static/media/Post-Listing-Microsite-Listed-Blocks-5.679bca8f.png";